import { Route, Routes } from 'react-router-dom'
import { Starter } from '../Starter/Starter'
import { ArtkonRouter } from './ArtkonRouter'
import { GameRouter } from './GameRouter'
import { QuizRouter } from './QuizRouter'
import { FontFreeRouter } from './FontFreeRouter.jsx'
import {SkeletonRouter} from './SkeletonRouter.jsx'
import {UiMasterRouter} from './UiMasterRouter.jsx'


export const MainRouter = () => {

    return (
        <Routes>
            <Route path='/' element={<Starter />}></Route>
            <Route path='/artkon/*' element={<ArtkonRouter />}></Route>
            <Route path='/Game/*' element={<GameRouter />}></Route>
            <Route path='/Quiz/*' element={<QuizRouter />}></Route>
            <Route path='/FontFree/*' element={<FontFreeRouter />}></Route>
            <Route path='/Skeleton/*' element={<SkeletonRouter />}></Route>
            <Route path='/UiMaster/*' element={<UiMasterRouter />}></Route>
        </Routes>
    )
}